/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { userSetupStatusStyles } from "@monsma/Overrides/Widgets/UserSetup/UserSetupStatus";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

(userSetupStatusStyles as any).container = {
    css: css`
        display: flex;
        flex-wrap: wrap;
    `,
};

userSetupStatusStyles.title = {
    variant: "h5",
    css: css`
        width: 100%;
    `,
};

userSetupStatusStyles.wrapper = {
    css: css`
        padding-bottom: 15px;
        font-weight: 400;
        width: 50%;
        padding: 0 15px;
        margin-bottom: 15px;

        ${screen("lt", "sm")} {
            width: 100%;
        }

        ${screen("lt", "md")} {
            padding: 0;
        }
    `,
};

userSetupStatusStyles.sendActivationEmailButton = {
    variant: "secondary",
    sizeVariant: "medium",
    css: css`
        ${screen("gt", "md")} {
            &.wrap-text {
                max-width: 100%;
                text-wrap: wrap;
                height: auto;
                padding: 5px;
            }
        }
    `
};
